import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/components/layout/PageHeader';
import { ICONS } from '@/constants/icons';

/** Header of the Brand Check page. Shared with RequireEntitlement so the locked state shows the identical header. */
export const BrandCheckPageHeader = () => {
  const { t } = useTranslation(['calendar', 'common']);
  return (
    <PageHeader
      title={
        <>
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <span className="text-bs-secondary">Ä</span>gile Brand Check
        </>
      }
      subtitle={t('brand_check_subtitle', {
        defaultValue: 'Visual consistency checker - see how your content looks together',
      })}
      icon={ICONS.RADAR}
      headerType="brandcheck"
      documentTitle="Ägile Brand Check"
    />
  );
};
